import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch } from "react-router-dom";

import Navbar from "components/Navbars/Navbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import { getSessionCookie } from "services/session.js";
import { api_GET } from "services/api_service.js";

//Routes
import routes from "../routes/routes";

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "black",
      activeColor: "info",
    };
    this.mainPanel = React.createRef();
  }
  componentDidMount() {
    this.validaPermissaoAcesso();      
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {        
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }  
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };

  validaPermissaoAcesso = () => {    
    let session = getSessionCookie();
    if (session && session.tipoAcesso == "Protocolo")
    {
      this.props.history.push('/auth/login');
      return;
    }    

    api_GET('usuario/ListaAcessoFuncionalidades/' + session.usuario_Id).then(result => {
      if (result.status === 200)
      {
        let newRoutes = [];
        //f => f.path.replace("/", "") != "inicio" && f.path.replace("/", "") != "trocarsenha")
        routes.map(m => {
          if (m.path == "/inicio" || m.path == "/trocarsenha")
            newRoutes.push(m);
          else if (session.login == "csj")
            newRoutes.push(m);          
          else if (result.data.filter(f => f == m.codigoPermissaoAcesso).length > 0)
            newRoutes.push(m);
        });
        this.setState({routes: newRoutes});
      }
    });

  }

  render() {
    return (
      <div>
        <div className="wrapper">
          {this.state.routes != null &&
            <Sidebar
              {...this.props}
              routes={this.state.routes}
              bgColor={this.state.backgroundColor}
              activeColor={this.state.activeColor}
            />
          }
          <div className="main-panel" ref={this.mainPanel}>
            <Navbar {...this.props} />
            <Switch>
              {this.state.routes != null && this.state.routes.map((prop, key) => {
                return (
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer fluid />
          </div>
        </div>
    </div>
    );
  }
}

export default Admin;
